import { NgModule, isDevMode } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { AppRoutingModule } from "@spartacus/storefront";
import { SGRECustomModules } from "./SGRE-custom/SGRE-custom.module";
import { SGRESharedModule } from "./SGRE-shared/SGRE-shared.module";
import { SpartacusModule } from "./spartacus/spartacus.module";

// Import MSAL and MSAL browser libraries
import { MsalModule } from '@azure/msal-angular';

// Import the Azure AD related Services
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthHttpHeaderService, AuthService } from "@spartacus/core";
import { MSALAuthHttpHeaderService } from "./SGRE-shared/services/login-sso/msal-auth-http-header.service";
import { MSALSpaAuthService } from "./SGRE-shared/services/login-sso/msal-auth.service";

// Custom OOTB Implementation
import { CustomProvidersConfig } from "./SGRE-config/custom-provider-config";
import { SpartacusFeaturesModule } from './spartacus/spartacus-features.module';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    SpartacusFeaturesModule,
    StoreModule.forRoot(),
    AppRoutingModule,
    EffectsModule.forRoot([]),
    SpartacusModule,
    SGRECustomModules,
    SGRESharedModule.forRoot(),
    MsalModule.forRoot(
      MSALSpaAuthService.msalInstance,
      {
        interactionType: 'redirect' as any,
        authRequest: {
          scopes: ['openid', 'profile', 'email']
        }
      },
      {
        interactionType: 'redirect' as any,
        protectedResourceMap: new Map()
      }
    ),
    StoreDevtoolsModule.instrument({
      name: 'SGRE SHOP',
      maxAge: 25,
      logOnly: !isDevMode()
    })
  ],
  providers: [
    provideAnimationsAsync(),
    {
      provide: AuthHttpHeaderService,
      useExisting: MSALAuthHttpHeaderService,
    },
    {
      provide: AuthService,
      useExisting: MSALSpaAuthService,
    },
    ...CustomProvidersConfig
  ]
})
export class AppModule { }
